import { defineNuxtPlugin } from '#app';

/**
 * Schuetzt Material-Icons/-Symbols vor Seiten-Uebersetzern.
 *
 * Material-Icons sind Text-Ligaturen: der Icon-Name steht als Textinhalt
 * (`<i class="material-icons">close</i>` → X-Glyph). Browser-Uebersetzer
 * (z.B. Microsoft Translator in Edge) uebersetzen diesen Text — aus "close"
 * wird "Schliessen" — wodurch die Ligatur bricht und die Icon-Schrift nur
 * noch Restzeichen rendert (User-Befund 2026-06-12: "S"/"ss" neben Feldern).
 *
 * `translate="no"` + class `notranslate` weisen Uebersetzer an, diese
 * Elemente zu ueberspringen. FontAwesome ist nicht betroffen (Glyph via
 * CSS-Pseudo-Element, kein uebersetzbarer Textknoten).
 *
 * Greift initial fuer den vorhandenen DOM und per MutationObserver fuer
 * spaeter eingefuegte Icons (SPA-Navigation, Modals, Listen).
 */
export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const SELECTOR =
    '[class*="material-icons"]:not([translate]),[class*="material-symbols"]:not([translate])';

  const protect = (el: Element) => {
    el.setAttribute('translate', 'no');
    el.classList.add('notranslate');
  };

  const scan = (root: ParentNode) => {
    root.querySelectorAll?.(SELECTOR).forEach(protect);
  };

  const start = () => {
    if (!document.body) return;
    scan(document.body);
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          const el = node as Element;
          if (el.matches?.(SELECTOR)) protect(el);
          scan(el);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.body) start();
  else window.addEventListener('DOMContentLoaded', start, { once: true });
});
